/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/network_direction.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns the direction type (inbound, outbound, internal, external) given a source IP address, destination IP address, and a list of internal networks.',
  examples: [
    'ROW ip0 = "127.0.0.1"::ip, ip1 = "5.6.7.8"::ip\n| EVAL direction = NETWORK_DIRECTION(ip0, ip1, ["loopback", "private"])',
  ],
  params: {
    source_ip: 'Source IP address of type `ip` (both IPv4 and IPv6 are supported).',
    destination_ip: 'Destination IP address of type `ip` (both IPv4 and IPv6 are supported).',
    internal_networks: 'List of internal networks. Supports IPv4 and IPv6 addresses, ranges in CIDR notation, and named ranges.',
  },
};

export default docs;
